<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('emvClearings.pageAll.title') }}</h2>
      <p class="text-center">
        {{ $t('emvClearings.pageAll.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <emv-clearing-payment-result-confirm :v-if="showPaymentResultConfirmButton" :show="showEdit"
                                               :form-details="editPaymentResult"
                                               @close="showEdit=false"/>
          <h4 slot="header" class="card-title">{{ $t('emvClearings.pageAll.tableTitle') }}</h4>
          <div>
            <div class="col-12 mb-3" v-if="$auth.can({audit_log: 'read'}, 'permissions')">
              <form class="d-flex justify-content-end align-items-center">

                  <el-input
                    type="search"
                    class="col-lg-3 col-md-3 col-sm-5 select-primary"
                    :placeholder="$t('generic.id')"
                    v-model="filterForm.clearingId"
                    aria-controls="datatables"
                  >
                  </el-input>

                  <el-input
                    type="search"
                    class="col-lg-3 col-md-3 col-sm-5 select-primary"
                    :placeholder="$t('emvClearings.details.payment_reference')"
                    v-model="filterForm.paymentReference"
                    aria-controls="datatables"
                  >
                  </el-input>

                <el-select
                  class="col-lg-3 col-md-3 col-sm-5 select-primary"
                  multiple
                  collapse-tags
                  v-model="filterForm.paymentResults"
                  :placeholder="$t('emvClearings.filterForm.selectPaymentResultsPlaceholder')"
                  :filterable="true"
                  :clearable="true"
                >
                  <el-option
                    v-for="item in availableEmvClearingPaymentResults"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>

                <base-button :loading="loading" type="default" @click="applyFilter" native-type="submit" class="ml-1">
                  <i class="tim-icons icon-light-3 pr-2"/> {{ $t('emvClearings.filterForm.filerBtnLabel') }}
                </base-button>
              </form>
            </div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col-6">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>

            <el-table v-loading="loading" :data="queriedData" show-header :row-class-name="tableRowClassName"
                      :cell-class-name="tableCellClassName"
                      :empty-text="$t('generic.noData')">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <emv-clearing-details :details="props.row"/>
                </template>
              </el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :prop="column.prop"
                :label="$t(column.label)"
                :formatter="column.formatter">
              </el-table-column>
              <el-table-column align="right" :min-width="50">
                <div slot-scope="props">
                  <base-button
                    v-if="$auth.isAdmin() && showPaymentResultConfirmButton(props.row)"
                    @click.native="handleEdit(props.$index, props.row)"
                    class="mr-2"
                    type="info"
                    size="sm"
                    icon
                    round
                    simple>
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <router-link
                    :to="{name: 'emvClearing', params: {id: props.row.id}}">
                    <i class="tim-icons icon-double-right"></i>
                  </router-link>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Option, Select, Table, TableColumn, Tooltip} from 'element-ui';
import {BaseAlert, BaseButton, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import EmvClearingDetails from 'src/components/EmvClearing/EmvClearingDetails';
import {mapActions, mapState} from "vuex";
import EmvClearingPaymentResultConfirm from "./EmvClearingPaymentResultConfirm";
import emv_clearing_payment_results from './emv_clearing_payment_results';

export default {
  name: 'emvClearingsPage',
  components: {
    BasePagination,
    BaseAlert,
    BaseButton,
    Tooltip,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    EmvClearingDetails,
    EmvClearingPaymentResultConfirm,
  },
  props: {},
  computed: {
    ...mapState({
      data: state => state.emv_clearings.data,
      loading: state => state.emv_clearings.loading,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      filterForm: {
        clearingId: "",
        paymentReference: "",
        paymentResults: [],
      },
      availableEmvClearingPaymentResults: emv_clearing_payment_results,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['payment_reference'],
      tableColumns: [
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 120,
        },
        {
          prop: 'business_day',
          label: 'emvClearings.details.business_day',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 120,
        },
        {
          prop: 'amount',
          label: 'emvClearings.details.amount',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.money(cellValue)
          },
          width: 100,
        },
        {
          prop: 'status',
          label: 'generic.status',
          width: 120,
        },
        {
          prop: 'clearing_result',
          label: 'emvClearings.details.clearing_result',
          width: 120,
        },
        {
          prop: 'payment_result',
          label: 'emvClearings.details.payment_result',
          width: 120,
        },
        {
          prop: 'payment_reference',
          label: 'emvClearings.details.payment_reference',
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      showEdit: false,
      editPaymentResult: {
        data: {}
      },
    };
  },
  methods: {
    ...mapActions(['LoadEmvClearings']),
    applyFilter: function (event) {
      if (event) {
        event.preventDefault()
      }
      this.LoadEmvClearings(this.filterForm)
    },
    showPaymentResultConfirmButton(row) {
      if (row["status"] !== "in_progress" || row["clearing_result"] !== "ADDED") {
        return false
      }
      switch (row["payment_result"]) {
        case "PAID":
        case "confirmed_manually":
        case "DEBT_PAID":
          return false;
      }
      return true; //props.row
    },
    handleEdit(index, row) {
      this.editPaymentResult = {
        id: row.id,
        data: {
          description: "",
          close_business_day: null,
        }
      };
      this.showEdit = true;
    },
    tableRowClassName({row}) {
      if (row["payment_result"] === "FAILED") {
        return 'bg-warning';
      }
      return '';
    },
    tableCellClassName({row, column}) {

      if (column.property === 'status') {
        switch (row["status"]) {
          case "open":
            return 'bg-info';
          case "in_progress":
          case "processed":
            return 'bg-warning';
          case "closed":
            return 'bg-success';
          default:
            return ''
        }
      }

      if (column.property === 'clearing_result') {
        switch (row["clearing_result"]) {
          case "ADDED":
            return 'bg-success';
          case "FAILED":
          case "unspecified":
            return 'bg-danger';
          default:
            return ''
        }
      }

      if (column.property === 'payment_result') {
        switch (row["payment_result"]) {
          case "ADDED":
          case "IN_DEBT":
            return "bg-warning";
          case "PAID":
          case "confirmed_manually":
          case "DEBT_PAID":
            return "bg-success";
          case "DEBT_FAILED":
          case "unspecified":
            return "bg-danger";
          default:
            return '';
        }
      }
      return '';
    },
  },
  mounted() {
    this.LoadEmvClearings(this.filterForm);
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "data"(data) {
      this.tableData = data
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
</style>
